var _title, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrowDecal = function SvgRightArrowDecal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 156"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Right arrow decal")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m0 78 108.75-67.55v135.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#FF4446"
  })));
};
export default SvgRightArrowDecal;